export default function HeadingTitle({ children }) {

    return (
        <h2 className="text-[#f7f8f8] py-6 text-2xl sm:text-3xl leading-tight tracking-tight font-semibold">
            {children}
        </h2>
    )
}
